// extracted by mini-css-extract-plugin
export default {"container":"FooterButtonApprovePoints_container__XgVOV"};